export const AI_GENERATED_IMAGE_SOURCES = {
    PROMPT_TO_IMAGE: 'PROMPT_TO_IMAGE',
    IMAGE_TO_IMAGE: 'IMAGE_TO_IMAGE',
};
